import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangePhoneWithPhoneLazy = lazyLoader(
  () =>
    import(
      './ChangePhoneWithPhone' /* webpackChunkName: "change-phone-webview" */
    ),
);

const ChangePhonePhoneWithPhone = () => {
  return (
    <Suspense fallback={null}>
      <ChangePhoneWithPhoneLazy />
    </Suspense>
  );
};

export default ChangePhonePhoneWithPhone;
